import { Box, styled } from '@mui/material';

import { colors } from '../../../../../theme';

export const SpinnerContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 120px 0;
    gap: 24px;
    width: 100%;
`;

export const SpinnerText = {
    font: '500 14px/17px "Inter", sans-serif',
    color: colors.white50
};

export const spinnerProgressSx = {
    color: colors.lightningYellow
};
